import { getIntegerIdsFromNexlaCustomCode } from './nexlaCustomCodeUtils';

/** Matches nexla_fn.call for getMap / toMapValue2 / toMapValue and captures the numeric map ID. */
const DATA_MAP_CALL_REGEX =
  /nexla_fn\.call\(\s*['"](getMap|toMapValue2|toMapValue)['"]\s*,\s*(\d+)\b/g;

/** Second capture group is the numeric map ID (first group is the function name). */
const DATA_MAP_ID_CAPTURE_INDEX = 2;

export function getDataMapIdsFromCustomCode(payload) {
  return getIntegerIdsFromNexlaCustomCode(payload, DATA_MAP_CALL_REGEX, DATA_MAP_ID_CAPTURE_INDEX);
}
